import request from '@/api/request.js';

// 发票列表
export const getInvoiceListPage = (data) => {
    return request({
        url: '/order/adm/invoice/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 发票详情
export const getInvoiceInfo = (data) => {
    return request({
        url: '/order/adm/invoice/getInvoiceInfo',
        method: 'post',
        type: 'json',
        data
    })
}

// 上传发票
export const uploadInvoice = (data) => {
    return request({
        url: '/order/adm/invoice/uploadInvoice',
        method: 'post',
        type: 'json',
        data
    })
}
